import type { SVGProps } from 'react'

import { cn } from '@/lib/utils'

type IconProps = SVGProps<SVGSVGElement>

export function StoryboardIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={14}
      stroke="currentColor"
      strokeWidth={1.8}
      viewBox="0 0 24 24"
      width={14}
      {...props}
    >
      <rect height={14} rx={1.5} width={8} x={3} y={5} />
      <rect height={6} rx={1.5} width={7} x={14} y={5} />
      <rect height={6} rx={1.5} width={7} x={14} y={13} />
    </svg>
  )
}

export function CropFramesIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={14}
      stroke="currentColor"
      strokeWidth={1.8}
      viewBox="0 0 24 24"
      width={14}
      {...props}
    >
      <rect height={18} rx={2} width={18} x={3} y={3} />
      <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
    </svg>
  )
}

export function StarIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      {...props}
    >
      <path
        d="m8 0 1.243 3.276a6 6 0 0 0 3.481 3.481L16 8l-3.276 1.243a6 6 0 0 0-3.481 3.481L8 16l-1.243-3.276a6 6 0 0 0-3.481-3.481L0 8l3.276-1.243a6 6 0 0 0 3.481-3.481z"
        fill="currentColor"
      />
    </svg>
  )
}

export function EnhanceIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={16}
      viewBox="0 0 20 20"
      width={16}
      {...props}
    >
      <path
        d="M9.74607 3.45707C9.85858 3.25456 10.1484 3.25056 10.2664 3.44989L12.2642 6.82303C12.527 7.26684 12.8998 7.63538 13.3467 7.89307L16.5637 9.74836C16.7606 9.86193 16.7646 10.1447 16.5709 10.2638L13.2747 12.2903C12.8739 12.5367 12.5367 12.8739 12.2903 13.2747L10.2638 16.5709C10.1447 16.7646 9.86193 16.7606 9.74836 16.5637L7.89307 13.3467C7.63538 12.8998 7.26684 12.527 6.82303 12.2642L3.44989 10.2664C3.25056 10.1484 3.25456 9.85858 3.45707 9.74607L6.75072 7.91627C7.24044 7.6442 7.6442 7.24044 7.91627 6.75072L9.74607 3.45707Z"
        fill="currentColor"
      />
      <path
        d="M15.7186 13.7604C15.8153 13.4992 16.1847 13.4992 16.2814 13.7604L16.3316 13.896C16.6354 14.7172 17.2828 15.3646 18.104 15.6684L18.2396 15.7186C18.5008 15.8153 18.5008 16.1847 18.2396 16.2814L18.104 16.3316C17.2828 16.6354 16.6354 17.2828 16.3316 18.104L16.2814 18.2396C16.1847 18.5008 15.8153 18.5008 15.7186 18.2396L15.6684 18.104C15.3646 17.2828 14.7172 16.6354 13.896 16.3316L13.7604 16.2814C13.4992 16.1847 13.4992 15.8153 13.7604 15.7186L13.896 15.6684C14.7172 15.3646 15.3646 14.7172 15.6684 13.896L15.7186 13.7604Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CharacterIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={20}
      viewBox="0 0 20 20"
      width={20}
      {...props}
    >
      <path
        d="M4.24244 15.8945C4.0461 16.2903 4.20779 16.7703 4.60359 16.9667C4.9994 17.163 5.47943 17.0013 5.67577 16.6055L4.95911 16.25L4.24244 15.8945ZM14.3206 16.6055C14.5169 17.0013 14.9969 17.163 15.3927 16.9667C15.7885 16.7703 15.9502 16.2903 15.7539 15.8945L15.0372 16.25L14.3206 16.6055ZM13.125 10H12.325C12.325 11.2841 11.2841 12.325 10 12.325V13.125V13.925C12.1677 13.925 13.925 12.1677 13.925 10H13.125ZM10 13.125V12.325C8.71594 12.325 7.675 11.2841 7.675 10H6.875H6.075C6.075 12.1677 7.83228 13.925 10 13.925V13.125ZM6.875 10H7.675C7.675 8.71594 8.71594 7.675 10 7.675V6.875V6.075C7.83228 6.075 6.075 7.83228 6.075 10H6.875ZM10 6.875V7.675C11.2841 7.675 12.325 8.71594 12.325 10H13.125H13.925C13.925 7.83228 12.1677 6.075 10 6.075V6.875ZM4.95911 16.25L5.67577 16.6055C6.07512 15.8005 6.69136 15.123 7.45505 14.6493L7.03339 13.9695L6.61173 13.2896C5.5948 13.9203 4.77422 14.8225 4.24244 15.8945L4.95911 16.25ZM7.03339 13.9695L7.45505 14.6493C8.21873 14.1757 9.09952 13.9247 9.99817 13.9247V13.1247V12.3247C8.80153 12.3247 7.62866 12.6589 6.61173 13.2896L7.03339 13.9695ZM9.99817 13.1247V13.9247C10.8968 13.9247 11.7776 14.1757 12.5413 14.6493L12.9629 13.9695L13.3846 13.2896C12.3677 12.6589 11.1948 12.3247 9.99817 12.3247V13.1247ZM12.9629 13.9695L12.5413 14.6493C13.305 15.123 13.9212 15.8005 14.3206 16.6055L15.0372 16.25L15.7539 15.8945C15.2221 14.8225 14.4015 13.9203 13.3846 13.2896L12.9629 13.9695ZM8 4V4.8H12V4V3.2H8V4ZM18 10H17.2V11H18H18.8V10H18ZM12 17V16.2H8V17V17.8H12V17ZM2 11H2.8V10H2H1.2V11H2ZM8 17V16.2C6.56317 16.2 5.56603 16.1983 4.81478 16.0973C4.08655 15.9994 3.71029 15.8216 3.44437 15.5556L2.87868 16.1213L2.31299 16.687C2.92575 17.2998 3.69593 17.5613 4.60159 17.683C5.48423 17.8017 6.6084 17.8 8 17.8V17ZM2 11H1.2C1.2 12.3916 1.1983 13.5158 1.31697 14.3984C1.43873 15.3041 1.70024 16.0743 2.31299 16.687L2.87868 16.1213L3.44437 15.5556C3.17844 15.2897 3.00061 14.9134 2.9027 14.1852C2.8017 13.434 2.8 12.4368 2.8 11H2ZM18 11H17.2C17.2 12.4368 17.1983 13.434 17.0973 14.1852C16.9994 14.9134 16.8216 15.2897 16.5556 15.5556L17.1213 16.1213L17.687 16.687C18.2998 16.0743 18.5613 15.3041 18.683 14.3984C18.8017 13.5158 18.8 12.3916 18.8 11H18ZM12 17V17.8C13.3916 17.8 14.5158 17.8017 15.3984 17.683C16.3041 17.5613 17.0743 17.2998 17.687 16.687L17.1213 16.1213L16.5556 15.5556C16.2897 15.8216 15.9134 15.9994 15.1852 16.0973C14.434 16.1983 13.4368 16.2 12 16.2V17ZM12 4V4.8C13.4368 4.8 14.434 4.8017 15.1852 4.9027C15.9134 5.00061 16.2897 5.17844 16.5556 5.44437L17.1213 4.87868L17.687 4.31299C17.0743 3.70024 16.3041 3.43873 15.3984 3.31697C14.5158 3.1983 13.3916 3.2 12 3.2V4ZM18 10H18.8C18.8 8.6084 18.8017 7.48423 18.683 6.60159C18.5613 5.69593 18.2998 4.92575 17.687 4.31299L17.1213 4.87868L16.5556 5.44437C16.8216 5.71029 16.9994 6.08655 17.0973 6.81478C17.1983 7.56603 17.2 8.56317 17.2 10H18ZM8 4V3.2C6.6084 3.2 5.48423 3.1983 4.60159 3.31697C3.69593 3.43873 2.92575 3.70024 2.31299 4.31299L2.87868 4.87868L3.44437 5.44437C3.71029 5.17844 4.08655 5.00061 4.81478 4.9027C5.56603 4.8017 6.56317 4.8 8 4.8V4ZM2 10H2.8C2.8 8.56317 2.8017 7.56603 2.9027 6.81478C3.00061 6.08655 3.17844 5.71029 3.44437 5.44437L2.87868 4.87868L2.31299 4.31299C1.70024 4.92575 1.43873 5.69593 1.31697 6.60159C1.1983 7.48423 1.2 8.6084 1.2 10H2Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function SceneIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={20}
      viewBox="0 0 20 20"
      width={20}
      {...props}
    >
      <path
        d="M2.5 10H9.0625M1.875 15.625H18.125M3.4375 10V15.625M8.125 10V15.625M2.5 12.8125H9.0625M15 15.625V12.5M15 2.5L17.5 12.5H12.5L15 2.5ZM10.625 5.3125C10.625 6.17544 9.92544 6.875 9.0625 6.875C8.19956 6.875 7.5 6.17544 7.5 5.3125C7.5 4.44956 8.19956 3.75 9.0625 3.75C9.92544 3.75 10.625 4.44956 10.625 5.3125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export function PropIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={20}
      viewBox="0 0 20 20"
      width={20}
      {...props}
    >
      <path
        d="M10 4.25 15.75 7.5v5L10 15.75 4.25 12.5v-5L10 4.25Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.6}
      />
      <path
        d="M10 4.25v11.5M4.25 7.5 10 10.75 15.75 7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export function RefImageIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={18}
      stroke="currentColor"
      strokeWidth={1.6}
      viewBox="0 0 24 24"
      width={18}
      {...props}
    >
      <rect height={14} rx={2} width={16} x={4} y={5} />
      <circle cx={9} cy={10} r={1.5} />
      <path d="M20 17l-4.5-4.5a1.5 1.5 0 0 0-2.1 0L4 20" />
    </svg>
  )
}

export function NanoIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={16}
      viewBox="0 0 20 18"
      width={16}
      {...props}
    >
      <path
        d="M16.567.027c.203 0 .914.241 1.067.386.08.056.203.281.254.387-.085.225-.255.792-.255 1.256s.61 1.288.915 1.642c1.779 1.498 1.423 4.445 1.423 4.445-.762 5.411-6.098 9.373-11.331 9.808-5.234.435-7.267-2.126-8.384-3.623-1.118-1.498 1.727-2.175 2.845-2.223s3.201-.338 6.098-1.594 4.42-4.445 4.573-4.928c.152-.483.66-1.208.711-1.401s.711-.822.864-1.16c.152-.338.203-.676.203-1.16s-.356-.676-.356-.772c0-.097-.254-.435 0-.822.255-.386 1.17-.241 1.373-.241"
        fill="currentColor"
      />
    </svg>
  )
}

export function GptIcon(props: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={16}
      viewBox="0 0 22 22"
      width={16}
      {...props}
    >
      <path
        d="M19.781 8.784a5.35 5.35 0 0 0-.46-4.392 5.41 5.41 0 0 0-5.824-2.594A5.35 5.35 0 0 0 9.464 0a5.41 5.41 0 0 0-5.158 3.744A5.35 5.35 0 0 0 .73 6.338a5.41 5.41 0 0 0 .665 6.34 5.35 5.35 0 0 0 .46 4.392 5.41 5.41 0 0 0 5.824 2.595 5.35 5.35 0 0 0 4.033 1.798 5.41 5.41 0 0 0 5.16-3.747 5.35 5.35 0 0 0 3.576-2.593 5.41 5.41 0 0 0-.667-6.34M11.714 20.06a4 4 0 0 1-2.575-.93l.127-.073 4.274-2.469a.7.7 0 0 0 .35-.608V9.955l1.807 1.043a.07.07 0 0 1 .035.05v4.99a4.027 4.027 0 0 1-4.018 4.021m-8.642-3.69a4 4 0 0 1-.48-2.696l.127.076 4.273 2.47a.7.7 0 0 0 .702 0l5.218-3.014v2.086a.07.07 0 0 1-.026.056l-4.32 2.494a4.026 4.026 0 0 1-5.494-1.472M1.947 7.04a4 4 0 0 1 2.095-1.763l-.002.147v4.937a.7.7 0 0 0 .35.608l5.218 3.012-1.806 1.043a.06.06 0 0 1-.061.005l-4.32-2.496A4.026 4.026 0 0 1 1.947 7.04m14.842 3.454L11.572 7.48l1.806-1.042a.07.07 0 0 1 .06-.006l4.321 2.494a4.024 4.024 0 0 1-.621 7.26V11.1a.7.7 0 0 0-.349-.607m1.798-2.706-.127-.076-4.273-2.468a.7.7 0 0 0-.702 0L8.266 8.255V6.17a.07.07 0 0 1 .026-.055l4.32-2.492a4.023 4.023 0 0 1 5.975 4.165M7.284 11.505l-1.807-1.043a.06.06 0 0 1-.035-.05v-4.99a4.023 4.023 0 0 1 6.597-3.088l-.127.072-4.274 2.47a.7.7 0 0 0-.351.606zm.981-2.116 2.324-1.342 2.324 1.342v2.683l-2.324 1.341-2.324-1.34z"
        fill="currentColor"
      />
    </svg>
  )
}

export function EngineIcon({
  icon,
  iconSvg,
  className,
  ...props
}: IconProps & { icon: 'nano' | 'gpt'; iconSvg?: string }) {
  if (iconSvg) {
    return (
      <span
        aria-hidden="true"
        className={cn('inline-flex size-4 shrink-0 items-center justify-center text-light-100', className)}
        dangerouslySetInnerHTML={{ __html: iconSvg }}
      />
    )
  }

  return icon === 'gpt' ? <GptIcon className={className} {...props} /> : <NanoIcon className={className} {...props} />
}

export function GuideSlotIcon({
  kind,
  ...props
}: IconProps & { kind: 'character' | 'scene' | 'prop' | 'image' }) {
  if (kind === 'character') return <CharacterIcon {...props} />
  if (kind === 'scene') return <SceneIcon {...props} />
  if (kind === 'prop') return <PropIcon {...props} />
  return <RefImageIcon {...props} />
}